var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Debug from '../util/Debug';
const authenticator = {
    authorize() {
        Debug.warn('Attempted to authorize on web. authorize() only works on native');
        return Promise.resolve('');
    },
    clear() {
        Debug.warn('Attempted to clear user session on web. clear() only works on native');
        return Promise.resolve();
    },
    getAccessToken() {
        Debug.warn('Attempted to get access token on web. getAccessToken() only works on native');
        return Promise.resolve(null);
    },
    isAccessTokenValid() {
        Debug.warn('Attempted to use access token on web. isAccessTokenValid() only works on native');
        return Promise.resolve(false);
    },
};
/**
 * No-op web implementation of hasAuthenticator()
 *
 * @returns false
 */
export const hasAuthenticator = () => {
    Debug.warn('Attempted to check authenticator on web. hasAuthenticator() only works on native');
    return false;
};
/**
 * No-op web implementation of initAuthenticator()
 */
export const initAuthenticator = () => {
    Debug.warn('Attempted to initialize authenticator on web. initAuthenticator() only works on native');
};
/**
 * Returns a no-op IAuthenticator web implementation
 *
 * @returns a no-op IAuthenticator implementation
 */
export const getAuthenticator = () => {
    Debug.warn('Attempted to get authenticator on web. getAuthenticator() only works on native');
    return authenticator;
};
/**
 * No-op web implementation of clearAuthenticator()
 *
 * @returns a no-op IAuthenticator implementation
 */
export const clearAuthenticator = () => __awaiter(void 0, void 0, void 0, function* () {
    Debug.warn('Attempted to clear authenticator on web. clearAuthenticator() only works on native');
});
//# sourceMappingURL=authenticatorFactory.web.js.map